import { ModalDialog } from './Modal';
import { ModalBody } from './ModalBody';
import { ModalClose } from './ModalClose';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
import { ModalTitle } from './ModalTitle';
export * from './Modal.decl';
export var Modal = {
  Dialog: ModalDialog,
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter,
  Title: ModalTitle,
  Close: ModalClose
};